// Generated from SVG to Code Figma Plugin

export const BaseFillLock = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 1C14.7614 1 17 3.23858 17 6V8H17.5C19.433 8 21 9.567 21 11.5V18.5C21 20.433 19.433 22 17.5 22H6.5C4.567 22 3 20.433 3 18.5V11.5C3 9.567 4.567 8 6.5 8H7V6C7 3.23858 9.23858 1 12 1ZM12 3C10.3431 3 9 4.34315 9 6V8H15V6C15 4.34315 13.6569 3 12 3Z"
      fill="currentColor"
    />
    <rect height="5" width="2" fill="#272A34" rx="1" x="11" y="12.5" />
  </svg>
);
